"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var LazyScriptLoader = /*#__PURE__*/function () {
  function LazyScriptLoader() {
    _classCallCheck(this, LazyScriptLoader);
    this.scripts = [];
    this.selector = "script[data-loading=\"lazy\"][data-src]";
    this.interactionEvents = ["mouseover", "keydown", "touchmove", "touchstart", "click"];
    this.loadAfterMsIfNoInteraction = 5000;
    this.loadTimer = null;
  }
  _createClass(LazyScriptLoader, [{
    key: "init",
    value: function init() {
      var _this = this;
      // find all scripts
      this.scripts = document.querySelectorAll(this.selector);

      // if there are no scripts, return
      if (this.scripts.length === 0) return;

      // load scripts on user interaction
      this.interactionEvents.forEach(function (event) {
        document.addEventListener(event, _this.startLoadingScripts.bind(_this), {
          passive: true
        });
      });

      // load scripts after a timeout if no user interaction
      this.loadTimer = setTimeout(this.startLoadingScripts.bind(this), this.loadAfterMsIfNoInteraction);
    }
  }, {
    key: "startLoadingScripts",
    value: function startLoadingScripts() {
      var _this2 = this;
      clearTimeout(this.loadTimer);
      this.loadScripts();
      this.interactionEvents.forEach(function (event) {
        document.removeEventListener(event, _this2.startLoadingScripts.bind(_this2), {
          capture: true
        });
      });
    }
  }, {
    key: "loadScripts",
    value: function loadScripts() {
      var _this3 = this;
      this.scripts.forEach(function (script) {
        if (script.dataset.loading === "loaded") return;
        _this3.loadScript(script);
      });
    }
  }, {
    key: "loadScript",
    value: function loadScript(script) {
      script.dataset.loading = "loaded";
      script.src = script.dataset.src;
      script.removeAttribute("data-src");
      console.log('loaded script', script.src);
    }
  }]);
  return LazyScriptLoader;
}();
var loader = new LazyScriptLoader();
window.onload = loader.init.bind(loader);